// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Montserrat_778051', '__Montserrat_Fallback_778051'","fontStyle":"normal"},"className":"__className_778051","variable":"__variable_778051"};